<template>
  <v-dialog v-model="visible" max-width="445" persistent>
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.deleteProject`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          :disabled="isLoading"
          @click.native="close(null)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text v-if="isValidObject(item)" class="px-4 pt-0 pb-5">
        {{ $t(`${namespace}.areYouSureDesc`) }} <strong>{{ item.name }}</strong>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer/>

        <a
          v-if="!isLoading"
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="close(null)"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          color="accent"
          depressed
          round
          @click.native="deleteProject"
        >
          {{ $t(`${namespace}.deleteProject`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { isObject } from 'utils/functions'

export default {
  name: 'SingleDeleteDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object
    }
  },
  data () {
    return {
      namespace: 'Views.ProjectsPage',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidObject (val) {
      return isObject(val)
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    async deleteProject () {
      let message = null
      this.isLoading = true

      try {
        await this.$apiService.deleteProject(this.item.id)
        this.close(true)
        message = {
          type: 'success',
          message: this.$t(`${this.namespace}.successDelete`)
        }
      } catch (err) {
        message = {
          type: 'error',
          message: this.$t(`${this.namespace}.errorDelete`)
        }
        console.log('ERROR:', err)
      }

      this.showAlert(message)
      this.isLoading = false
    }
  }
}
</script>
